import { GridCellProps } from '@progress/kendo-react-grid';
import { AdminProfileInfo } from 'app/components/AdminProfileInfo';

type Props = {
  className?: string;
  e: GridCellProps;
  onClick?: (e) => void;
};

const CoachProfileCell = ({ className, e, onClick }: Props) => {
  const data = e?.dataItem;
  const hasCoaches = data?.coaches && data.coaches.length > 0;

  return (
    <td className={className ?? ''}>
      {hasCoaches ? (
        <AdminProfileInfo
          // src={data?.coach?.imageUrl ?? ''}
          mainLabel={
            'Main: ' +
            (data.coaches
              .filter(a => a.isMain === true)
              .map(coach => coach.name)
              .join(', ') || 'Not Assigned')
          }
          name={
            'Coaches: ' +
            (data?.coaches
              .filter(a => a.isAssistant !== true)
              .map(coach => coach.name)
              .join(', ') || 'Not Assigned')
          }
          subLabel={
            'Assistant: ' +
            (data?.coaches
              .filter(a => a.isAssistant === true)
              .map(coach => coach.name)
              .join(', ') || 'Not Assigned')
          }
        />
      ) : (
        <AdminProfileInfo mainLabel="Not Assigned" name="" subLabel="" />
      )}
    </td>
  );
};

export default CoachProfileCell;
